import * as React from 'react';
import { Routes, Route } from 'react-router';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import withWaitingComponent from 'Common/HOC/withWaitingComponent';
import ErrorBoundary from 'Common/pages/error';
import PusherProvider from 'utils/PusherProvider';

const Products = React.lazy(
  () =>
    import(
      /* webpackChunkName: "productsModule" */
      './screens/Products'
    )
);

const Services = React.lazy(
  () =>
    import(
      /* webpackChunkName: "servicesModule" */
      './screens/Services'
    )
);

const Giftcards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "giftcardsModule" */
      './screens/Giftcards'
    )
);

const Stocktaking = React.lazy(
  () =>
    import(
      /* webpackChunkName: "stocktakingModule" */
      './screens/Stocktaking'
    )
);

const Categories = React.lazy(
  () =>
    import(
      /* webpackChunkName: "categoriesManagementModule" */
      './screens/Categories'
    )
);

const InventoryRouter = () => {
  const [account] = useLocalStorageState<AccountPersistInfo>('account');

  return (
    <PusherProvider>
      {account !== undefined && (
        <Routes>
          <Route
            path="products"
            element={
              account.isActive ? (
                withWaitingComponent(Products)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route
            path="stocktaking"
            element={
              account.isActive ? (
                withWaitingComponent(Stocktaking)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route
            path="services"
            element={
              account.isActive ? (
                withWaitingComponent(Services)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route
            path="giftcards"
            element={
              account.isActive || account.hasGiftcardsV2Sub ? (
                withWaitingComponent(Giftcards)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route
            path="categories"
            element={
              account.isActive ? (
                withWaitingComponent(Categories)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route path="*" element={<ErrorBoundary />} />
        </Routes>
      )}
    </PusherProvider>
  );
};

export default InventoryRouter;
